import PlayerProgressTrackerContent from '@/features/guardian-player/components/player-progress-tracker';
import { useGuardianStackNavigation } from '@/hooks';
import type { GuardianStackScreenProps } from '@/navigations/types';
import { useRoute } from '@react-navigation/native';
import React, { useCallback } from 'react';

type PlayerProgressTrackerRoute = GuardianStackScreenProps<'PlayerProgressTracker'>['route'];

const PlayerProgressTrackerScreen = () => {
  const navigation = useGuardianStackNavigation();
  const route = useRoute<PlayerProgressTrackerRoute>();
  const { player } = route.params;

  const handleOpenLevelDetail = useCallback(
    (level: number) => {
      navigation.navigate('GuardianPlayerLevelDetail', {
        level,
        player,
      });
    },
    [navigation, player],
  );

  const handleOpenSessionHistory = useCallback(() => {
    navigation.navigate('PlayerSessionHistories', { player });
  }, [navigation, player]);

  return (
    <PlayerProgressTrackerContent
      player={player}
      onBack={navigation.goBack}
      onOpenLevelDetail={handleOpenLevelDetail}
      onOpenSessionHistory={handleOpenSessionHistory}
    />
  );
};

export default PlayerProgressTrackerScreen;
